import CommonModal from 'components/common/CommonModal';
import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import Pagination from 'components/common/Pagination';
import moment from 'moment-timezone';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {localeState, userInfoState} from 'utils/Atoms';
import {searchBackOfficeTongPlace} from 'function/api';
import {convertTotalPage} from 'function/converter';
import {changeLocaleType, formatPhoneNumber} from 'utils/fomatPhoneNumber';
import {CountryCode} from 'libphonenumber-js';
import {formatBusinessRegisterNumber} from 'function/formatter';
import BusinessImgModal from 'components/main/BusinessImgModal';
import ChangeStateModal from 'components/main/ChangeStateModal';
import {ResponseSearchBackOfficeTongPlace} from 'interfaces/interface';
import LabelInput from 'components/common/LabelInput';
import ContainerHeader from 'components/common/ContainerHeader';

/**
 * 사용자 관리 현장 목록 페이지 컴포넌트
 * 현장 목록을 조회하고 관리하는 페이지입니다.
 * @returns {JSX.Element} 사용자 관리 현장 목록 페이지 컴포넌트
 */
const UserManagementTongPlace = () => {
  // locale
  const locale = useRecoilValue(localeState);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});

  const navigate = useNavigate();

  const userInfo = useRecoilValue(userInfoState);

  const [tongCurrentPage, setTongCurrentPage] = useState(1);
  const [tongTotalPage, setTongTotalPage] = useState(1);

  const [tongData, setTongData] =
    useState<null | ResponseSearchBackOfficeTongPlace>(null);

  const [modal, setModal] = useState('');

  const [selectItem, setSelectItem] = useState<null | any>(null);

  const [keyword, setKeyword] = useState('');

  const modalData: {[key: string]: any} = {
    // 본사시스템 서비스 준비중
    servicePreparing: {
      title: 'servicePreparing',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
      },
    },
    changeBusinessRegisterNumberImg: {
      title: '사업자등록증 변경 성공',
      detail: '사업자등록증 변경이 완료되었습니다!',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
        window.location.reload();
      },
    },
    completeHide: {
      title: '현장 숨김 처리 완료',
      detail: '현장 숨김 처리가 완료되었습니다!',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
        window.location.reload();
      },
    },
    completeShow: {
      title: '현장 숨김 해제 완료',
      detail: '현장 숨김 해제가 완료되었습니다!',
      firstButtonText: 'confirm',
      firstButtonClick: () => {
        setModal('');
        window.location.reload();
      },
    },
  };

  useEffect(() => {
    if (!userInfo?.accessToken) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    if (userInfo?.accessToken) {
      searchBackOfficeTongPlace({
        userInfo,
        setErrorModal,
        setIsLoading,
        keyword,
        page: tongCurrentPage,
      }).then(result => {
        if (result) {
          setTongData(result);

          const resTotalPage = convertTotalPage(result.totalCount ?? 0, 10);
          setTongTotalPage(resTotalPage);
        }
      });
    }
  }, [userInfo, tongCurrentPage]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="userManagement" subTitle="tongPlace" />

        <Inner>
          {/* 현장 리스트 - 사용X / 임시 복원 */}
          <DefaultText
            text="tongPlace"
            textStyle={{
              fontSize: minmax(30),
              fontWeight: 'bold',
              borderBottom: `3px solid ${colors.primary}`,
              width: 'fit-content',
              marginBottom: minmax(20),
            }}
          />

          <SearchContainer>
            <LabelInput
              type={'text'}
              labelText={''}
              value={keyword}
              labelInputContainerStyle={{flex: 1}}
              labelStyle={{display: 'none'}}
              rightImg="images/common/search.png"
              placeholder="searchPlaceholder"
              onClickRightImg={async () => {
                searchBackOfficeTongPlace({
                  userInfo,
                  setErrorModal,
                  setIsLoading,
                  page: 1,
                  keyword,
                }).then(result => {
                  if (result) {
                    setTongData(result);

                    const resTotalPage = convertTotalPage(
                      result.totalCount ?? 0,
                      10,
                    );
                    setTongTotalPage(resTotalPage);
                    setTongCurrentPage(1);
                  }
                });
              }}
              setValue={(e: any) => setKeyword(e)}
              inputStyle={{paddingRight: minmax(70)}}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  searchBackOfficeTongPlace({
                    userInfo,
                    setErrorModal,
                    setIsLoading,
                    page: 1,
                    keyword,
                  }).then(result => {
                    if (result) {
                      setTongData(result);

                      const resTotalPage = convertTotalPage(
                        result.totalCount ?? 0,
                        10,
                      );
                      setTongTotalPage(resTotalPage);
                      setTongCurrentPage(1);
                    }
                  });
                }
              }}
            />
          </SearchContainer>

          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />
              <DefaultText
                text="registerDate"
                textStyle={ResultHeaderTextStyle}
              />
              <DefaultText text="applicant" textStyle={ResultHeaderTextStyle} />
              <DefaultText
                text="applicantNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="siteName"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="siteAddress"
                textStyle={{...ResultHeaderTextStyle, flex: 2}}
              />
              <DefaultText
                text="businessRegistrationNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="DUNS"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
              <DefaultText
                text="onsitePhoneNumber"
                textStyle={{...ResultHeaderTextStyle, flex: 1.5}}
              />
            </ResultHeader>

            <ResultList>
              {tongData?.totalCount ? (
                tongData.tongPlaceList.map((item, index: number) => (
                  <ResultItem
                    key={item.uuid}
                    onClick={() => {
                      //
                      navigate(`/userManagementTongPlaceDetail`, {
                        state: {uuid: item.uuid},
                      });
                    }}>
                    <DefaultText
                      text={((tongCurrentPage - 1) * 10 + index + 1).toString()}
                      textStyle={{...ResultHeaderTextStyle, flex: 0.4}}
                    />
                    <DefaultText
                      text={moment(item.createdAt).format('YY-MM-DD')}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={item.owner.profile?.name || '-'}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={formatPhoneNumber({
                        phone: item.owner.phone,
                        locale: item.owner.locale,
                      })}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.name}
                      textStyle={{...ResultItemStyle, flex: 2}}
                    />
                    <DefaultText
                      text={
                        item.address +
                        (item.addressDetail ? ', ' + item.addressDetail : '')
                      }
                      textStyle={{...ResultItemStyle, flex: 2}}
                    />
                    <DefaultText
                      text={formatBusinessRegisterNumber(
                        item.businessRegisterNumber,
                      )}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={item.dunsNumber || '-'}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                    <DefaultText
                      text={formatPhoneNumber({
                        phone: item.tongPlaceNumber,
                        locale: item.locale,
                      })}
                      textStyle={{...ResultItemStyle, flex: 1.5}}
                    />
                  </ResultItem>
                ))
              ) : (
                <DefaultText
                  text="noDataMsgTongList"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {tongData?.totalCount ? (
            <Pagination
              totalPage={tongTotalPage}
              currentPage={tongCurrentPage}
              setCurrentPage={setTongCurrentPage}
            />
          ) : null}
        </Inner>
      </Container>

      {modal !== '' && (
        <CommonModal
          title={modalData[modal].title}
          detail={modalData[modal].detail}
          firstButtonText={modalData[modal].firstButtonText}
          firstButtonStyle={modalData[modal].firstButtonStyle}
          secondButtonText={modalData[modal].secondButtonText}
          secondButtonStyle={modalData[modal].secondButtonStyle}
          firstButtonClick={modalData[modal].firstButtonClick}
          secondButtonClick={modalData[modal].secondButtonClick}
          closeModal={modalData[modal].firstButtonClick}
        />
      )}

      {/* 상태 변경 | 사업자등록증 모달 */}
      {selectItem &&
        (selectItem.type === 'state' ? (
          <ChangeStateModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : selectItem.type === 'business' ? (
          <BusinessImgModal
            selectItem={selectItem}
            closeModal={() => setSelectItem(null)}
            setIsLoading={setIsLoading}
            setErrorModal={setErrorModal}
          />
        ) : null)}
    </ScreenLayout>
  );
};

export default UserManagementTongPlace;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(20)};
`;

const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: ${minmax(20)};
  column-gap: ${minmax(20)};
`;

const Border = styled.div`
  width: 1px;
  height: ${minmax(60)};
  background-color: ${colors.borderGray};
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  fontSize: minmax(20),
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const TitleText = styled.p`
  font-size: max(18px, min(2vw, 36px));
  font-weight: 500;
  letter-spacing: -1.08px;
  color: ${colors.black};
  margin-bottom: max(28px, min(2vw, 34px));
  text-align: center;
`;

const WarningModalContainer = styled.div`
  min-width: minmax(600);
  display: flex;
  flex-direction: column;
  row-gap: minmax(30);
  justify-content: center;
  align-items: center;
`;
